import { useCallback } from "react";

export const useTooltip = () => {
  const showTooltip = useCallback((e, content) => {
    // Remove any existing tooltip first
    const existingTooltip = document.querySelector(".tooltip");
    if (existingTooltip) {
      document.body.removeChild(existingTooltip);
    }

    if (!content) {
      console.warn("Tooltip content is undefined or null");
      return;
    }

    if (typeof content === "object" && Object.keys(content).length === 0) {
      console.warn("Tooltip content is an empty object");
      return;
    }

    const tooltip = document.createElement("div");
    tooltip.className = "tooltip";

    // Handle both string and object content
    if (typeof content === "string") {
      tooltip.textContent = content;
    } else if (typeof content === "object" && content !== null) {
      // For address objects or other structured data
      if (content.Street && content.City) {
        tooltip.textContent = `${content.Street}, ${content.City}, ${content.State} ${content.Zip}`;
      } else {
        tooltip.textContent = JSON.stringify(content);
      }
    } else {
      tooltip.textContent = String(content);
    }

    document.body.appendChild(tooltip);

    const rect = e.target.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    // Position tooltip above the element
    tooltip.style.top = `${
      rect.top + window.scrollY - tooltipRect.height - 8
    }px`;
    tooltip.style.left = `${
      rect.left + window.scrollX + (rect.width - tooltipRect.width) / 2
    }px`;

    // Ensure tooltip stays within viewport
    const viewportWidth = window.innerWidth;
    const tooltipLeft = parseInt(tooltip.style.left);

    if (tooltipLeft < 10) {
      tooltip.style.left = "10px";
    } else if (tooltipLeft + tooltipRect.width > viewportWidth - 10) {
      tooltip.style.left = `${viewportWidth - tooltipRect.width - 10}px`;
    }
  }, []);

  const hideTooltip = useCallback(() => {
    const tooltip = document.querySelector(".tooltip");
    if (tooltip) {
      document.body.removeChild(tooltip);
    }
  }, []);

  return {
    showTooltip,
    hideTooltip,
  };
};
